import LinearGradient from 'react-native-linear-gradient';
import { setLinearGradientComponent } from './LinearGradient';
setLinearGradientComponent(LinearGradient);

export { MotionLinearGradient, LinearGradientPoint, LinearGradientProps } from './LinearGradient';
